import { MODE } from 'containers/CourtManagerLegalProceedings/ExpertReport/constants';
import { CURRENT_JUDICIARY_STEP_EXPERT_REPORT } from 'containers/CourtManagerLegalProceedings/ExpertReportAppeal/constants';
import { STATUS_VALIDATED } from 'containers/LawyerFeeNote/constants';
import { MANAGEMENT_MODES } from 'containers/RecapManagerPage/constants';
import { get, isEmpty, isNil } from 'lodash';
import { TransactionType } from 'typings/globalTypes';
import { getTheLatestEvaluationObject } from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate/utils';
import { getVictimAge } from 'containers/CourtManagerLegalProceedings/ExpertReport/utils';
import moment from 'moment';

export const formatLastEvaluation = (
  lastEvaluationTransactionVictim: any,
  victimAge: any,
  victim: any,
  responsibilityRate: string,
  status: string,
  lastEvaluationOfOtherVictim: any,
  victims: any,
  lossDate: Date,
) => {
  if (
    status === STATUS_VALIDATED &&
    !isEmpty(lastEvaluationTransactionVictim) &&
    !isEmpty(lastEvaluationOfOtherVictim)
  ) {
    const evaluationTransactionVictim = {
      gestionMode: '',
      materialAmount: '',
      currentJudiciaryStep: CURRENT_JUDICIARY_STEP_EXPERT_REPORT,
      judiciaryAmount: '',
      responsibilityRate: String(responsibilityRate),
      age: victimAge,
      rateRecovery: String(lastEvaluationTransactionVictim.rateRecovery),
      revenu: !isNil(victim.annualOfIncome)
        ? String(victim.annualOfIncome)
        : String(lastEvaluationTransactionVictim.revenu),
      mode: get(victim, 'injuryPostKey') === '2' ? MODE.DECEASED : MODE.BLESSE,
      ratePretium: String(lastEvaluationTransactionVictim.ratePretium),
      rateAestheticDamageWithoutConsequence: String(
        lastEvaluationTransactionVictim.rateAestheticDamageWithoutConsequence,
      ),
      rateAestheticDamageWithConsequence: String(
        lastEvaluationTransactionVictim.rateAestheticDamageWithConsequence,
      ),
      rateCareerPrejudice: String(
        lastEvaluationTransactionVictim.rateCareerPrejudice,
      ),
      rateSchoolingPrejudice: String(
        lastEvaluationTransactionVictim.rateSchoolingPrejudice,
      ),
      rateIPP: String(lastEvaluationTransactionVictim.rateIPP),
      rateITT: String(lastEvaluationTransactionVictim.rateITT),
      victimKey: get(victim, 'victimKey'),
      medicalPharmaceuticalFees: String(
        lastEvaluationTransactionVictim.medicalPharmaceuticalFees,
      ),
      rateMedicalPharmaceuticalFees: String(
        lastEvaluationTransactionVictim.rateMedicalPharmaceuticalFees,
      ),
      transactionPhase: 0,
      JudiciartDecisionDate: '',
      expType: '',
      lossDate: moment(lossDate).toISOString(true),
      isRecentExpertiseVictim: false,
    };
    const otherEvaluations = lastEvaluationOfOtherVictim?.map((item: any) => ({
      gestionMode: '',
      materialAmount: '',
      currentJudiciaryStep: CURRENT_JUDICIARY_STEP_EXPERT_REPORT,
      judiciaryAmount: '',
      responsibilityRate: String(responsibilityRate),
      age: getVictimAge(
        get(findVictimInfo(victims, item.victimKey), 'id'),
        [findVictimInfo(victims, item.victimKey)],
        (lossDate as unknown) as string,
      ),
      rateRecovery: String(item.rateRecovery),
      revenu: String(item.revenu),
      lossDate: moment(lossDate).toISOString(true),
      mode:
        get(findVictimInfo(victims, item.victimKey), 'injuryPostKey') === '2'
          ? MODE.DECEASED
          : MODE.BLESSE,
      ratePretium: String(item.ratePretium),
      rateAestheticDamageWithoutConsequence: String(
        item.rateAestheticDamageWithoutConsequence,
      ),
      rateAestheticDamageWithConsequence: String(
        item.rateAestheticDamageWithConsequence,
      ),
      rateCareerPrejudice: String(item.rateCareerPrejudice),
      rateSchoolingPrejudice: String(item.rateSchoolingPrejudice),
      rateIPP: String(item.rateIPP),
      rateITT: String(item.rateITT),
      victimKey: get(findVictimInfo(victims, item.victimKey), 'victimKey'),
      medicalPharmaceuticalFees: String(item.medicalPharmaceuticalFees),
      rateMedicalPharmaceuticalFees: String(item.rateMedicalPharmaceuticalFees),
      transactionPhase: 0,
      JudiciartDecisionDate: '',
      expType: '',
      isRecentExpertiseVictim: false,
    }));
    return [...[evaluationTransactionVictim], ...otherEvaluations];
  } else if (
    status === STATUS_VALIDATED &&
    !isEmpty(lastEvaluationTransactionVictim)
  ) {
    const evaluationTransactionVictim = [
      {
        gestionMode: '',
        materialAmount: '',
        currentJudiciaryStep: CURRENT_JUDICIARY_STEP_EXPERT_REPORT,
        judiciaryAmount: '',
        responsibilityRate: String(responsibilityRate),
        lossDate: moment(lossDate).toISOString(true),
        age: victimAge,
        rateRecovery: String(lastEvaluationTransactionVictim.rateRecovery),
        revenu: !isNil(victim.annualOfIncome)
          ? String(victim.annualOfIncome)
          : String(lastEvaluationTransactionVictim.revenu),
        mode:
          get(victim, 'injuryPostKey') === '2' ? MODE.DECEASED : MODE.BLESSE,
        ratePretium: String(lastEvaluationTransactionVictim.ratePretium),
        rateAestheticDamageWithoutConsequence: String(
          lastEvaluationTransactionVictim.rateAestheticDamageWithoutConsequence,
        ),
        rateAestheticDamageWithConsequence: String(
          lastEvaluationTransactionVictim.rateAestheticDamageWithConsequence,
        ),
        rateCareerPrejudice: String(
          lastEvaluationTransactionVictim.rateCareerPrejudice,
        ),
        rateSchoolingPrejudice: String(
          lastEvaluationTransactionVictim.rateSchoolingPrejudice,
        ),
        rateIPP: String(lastEvaluationTransactionVictim.rateIPP),
        rateITT: String(lastEvaluationTransactionVictim.rateITT),
        victimKey: get(victim, 'victimKey'),
        medicalPharmaceuticalFees: String(
          lastEvaluationTransactionVictim.medicalPharmaceuticalFees,
        ),
        rateMedicalPharmaceuticalFees: String(
          lastEvaluationTransactionVictim.rateMedicalPharmaceuticalFees,
        ),
        transactionPhase: 0,
        JudiciartDecisionDate: '',
        expType: '',
        isRecentExpertiseVictim: false,
      },
    ];
    return evaluationTransactionVictim;
  } else if (status === STATUS_VALIDATED) {
    return [
      {
        gestionMode: '',
        materialAmount: '',
        currentJudiciaryStep: CURRENT_JUDICIARY_STEP_EXPERT_REPORT,
        judiciaryAmount: '',
        responsibilityRate: String(responsibilityRate),
        age: victimAge,
        rateRecovery: '',
        lossDate: moment(lossDate).toISOString(true),
        revenu: !isNil(victim.annualOfIncome)
          ? String(victim.annualOfIncome)
          : null,
        mode:
          get(victim, 'injuryPostKey') === '2' ? MODE.DECEASED : MODE.BLESSE,
        ratePretium: '',
        rateAestheticDamageWithoutConsequence: '',
        rateAestheticDamageWithConsequence: '',
        rateCareerPrejudice: '',
        rateSchoolingPrejudice: '',
        rateIPP: '',
        rateITT: get(victim, 'itt'),
        victimKey: get(victim, 'victimKey'),
        medicalPharmaceuticalFees: '',
        rateMedicalPharmaceuticalFees: '',
        transactionPhase: 0,
        JudiciartDecisionDate: '',
        expType: '',
        isRecentExpertiseVictim: false,
      },
    ];
  } else {
    return [];
  }
};

export const formatTransactionCircumstances = (
  status: string,
  transactionInfo: TransactionType,
  riskId: string,
) => {
  if (status === STATUS_VALIDATED) {
    return {
      scaleCaseCode: get(transactionInfo, 'scaleCase.scaleCaseKey', {}),
      circumstanceCode: get(
        transactionInfo,
        'scaleCase.accidentCirconstanceKey',
        {},
      ),
      responsabilityRate: get(
        transactionInfo,
        'scaleCase.responsabilityKey',
        {},
      ),
      managementMode: MANAGEMENT_MODES.COMMON_RIGHT,
      riskId: riskId,
      isFromCorporel: true,
    };
  } else {
    return {};
  }
};

export const formatClaimCircumstances = (
  transactionInfo: TransactionType,
  status: string,
) => {
  if (status === STATUS_VALIDATED) {
    return {
      managementModeKey: MANAGEMENT_MODES.COMMON_RIGHT,
      scaleCaseKey: get(transactionInfo, 'scaleCase.scaleCaseKey', {}),
      accidentCirconstanceKey: get(
        transactionInfo,
        'scaleCase.accidentCirconstanceKey',
      ),
      responsabilityKey: get(
        transactionInfo,
        'scaleCase.responsabilityKey',
        {},
      ),
      responsibilityShare: Number(
        get(transactionInfo, 'scaleCase.responsibilityShare'),
      ),
      accidentCirconstance: get(
        transactionInfo,
        'scaleCase.accidentCirconstance',
      ),
      validationComment: get(
        transactionInfo,
        'scaleCase.accidentDescription',
        '',
      ),
    };
  } else {
    return {};
  }
};

export const lastEvaluationOfOtherVictims = (
  victims: any,
  dahirAmounts: any,
) => {
  return victims?.map((el: any) =>
    getTheLatestEvaluationObject(el.victimKey, dahirAmounts),
  );
};

export const findVictimInfo = (victims: any, victimKey: string) => {
  return victims.find((el: any) => String(el.victimKey) === String(victimKey));
};
